import Link from 'next/link';
import cn from 'classnames';
import settings from '@/settings';
import { generateWarrantyDisclaimer } from '@/lib/reebelocare/helpers';

const WarrantyDisclaimer = ({ className }: { className?: string }) => {
  if (settings.store === 'reebelo-ca') {
    return (
      <div
        className={cn(
          'mt-5 text-center text-xs leading-tight text-gray-700/70',
          className,
        )}
      >
        <div>
          {generateWarrantyDisclaimer()}{' '}
          <Link href="https://edge.reebelo.com/files/sqt/PDS-CA.pdf" passHref>
            <a className="underline" target="_blank" rel="noopener noreferrer">
              T&C Applies
            </a>
          </Link>{' '}
          /{' '}
          <Link href="https://edge.reebelo.com/files/sqt/PDS-FRCA.pdf" passHref>
            <a className="underline" target="_blank" rel="noopener noreferrer">
              T&C s'appliquent
            </a>
          </Link>
        </div>
        <div className="mt-1">
          Notice for Quebec residents:{' '}
          <Link href="https://edge.reebelo.com/files/sqt/IWI-CA.pdf" passHref>
            <a className="underline" target="_blank" rel="noopener noreferrer">
              Important Warranty Information / Avis important sur la garantie
              légale
            </a>
          </Link>
        </div>
      </div>
    );
  }

  if (settings.store !== 'reebelo-au') {
    return (
      <div
        className={cn(
          'mt-5 text-center text-xs leading-tight text-gray-700/70',
          className,
        )}
      >
        {generateWarrantyDisclaimer()}{' '}
        <Link href="/policies/warranty-and-refund-policy" passHref>
          <a className="underline" target="_blank" rel="noopener noreferrer">
            T&C Applies
          </a>
        </Link>
      </div>
    );
  }

  return (
    <div className="mt-5 text-center text-xs leading-tight text-gray-700/70">
      By purchasing ReebeloCare you agree to the terms and conditions set in the{' '}
      <Link href="https://edge.reebelo.com/files/sqt/01-PDS.pdf">
        <a target="_blank" className="text-blue-500 underline">
          Product Disclosure Statement
        </a>
      </Link>{' '}
      and acknowledge the{' '}
      <Link href="https://edge.reebelo.com/files/sqt/03-FSG.pdf">
        <a target="_blank" className="text-blue-500 underline">
          Financial Services Guide
        </a>
      </Link>
      . You can also read the Target Market Determination{' '}
      <Link href="https://edge.reebelo.com/files/sqt/02-TMD.pdf">
        <a target="_blank" className="text-blue-500 underline">
          here
        </a>
      </Link>
      .
    </div>
  );
};

export default WarrantyDisclaimer;
